
(function () {
  function initialiseDedicatedBundles() {
    document.querySelectorAll('.pc-dedicated').forEach(function (builder) {
      if (builder.dataset.initialised === 'true') return;
      builder.dataset.initialised = 'true';

      // Elements
      const plans = Array.from(builder.querySelectorAll('.pc-dedicated-plan'));
      const list = builder.querySelector('.pc-bundle-list');
      const rows = Array.from(builder.querySelectorAll('.pc-bundle-row'));
      const search = builder.querySelector('.pc-bundle-search');
      const clearSearch = builder.querySelector('.pc-bundle-search-clear');
      const counter = builder.querySelector('[data-pc-count]');
      const limitDisplay = builder.querySelector('[data-pc-limit]');
      const instruction = builder.querySelector('[data-pc-instruction]');
      const summary = builder.querySelector('.pc-bundle-selections');
      const priceDisplay = builder.querySelector('[data-pc-price]');
      const compareDisplay = builder.querySelector('[data-pc-compare]');
      const savingDisplay = builder.querySelector('[data-pc-saving]');
      const cartButton = builder.querySelector('.pc-bundle-cart');

      // Bundle state
      let limit = Number(builder.dataset.bundleSize) || 3;
      let price = Number(
        plans.find(plan => Number(plan.dataset.size) === limit)?.dataset.price
      ) || 50;

      const selected = new Map();
      const individualPrice = 18.99;

      function totalSelected() {
        let total = 0;
        selected.forEach(item => total += item.quantity);
        return total;
      }

      // Sort perfumes by numerical reference, then suffix.
      function referenceParts(reference) {
        const match = String(reference).match(/^(\d+)(.*)$/);

        return match
          ? [Number(match[1]), match[2].toUpperCase()]
          : [Number.MAX_SAFE_INTEGER, String(reference)];
      }

      rows.sort(function (a, b) {
        const first = referenceParts(a.dataset.reference);
        const second = referenceParts(b.dataset.reference);

        return first[0] - second[0] ||
          first[1].localeCompare(second[1]);
      });

      rows.forEach(row => list.appendChild(row));

      // Add or remove a perfume.
      function changeQuantity(row, difference) {
        const id = row.dataset.variantId;
        const existing = selected.get(id);
        const currentQuantity = existing ? existing.quantity : 0;
        const newQuantity = currentQuantity + difference;

        if (newQuantity < 0) return;
        if (difference > 0 && totalSelected() >= limit) return;

        if (newQuantity === 0) {
          selected.delete(id);
        } else {
          selected.set(id, {
            title: row.dataset.productTitle,
            quantity: newQuantity
          });
        }

        update();
      }

      // Create quantity controls for available perfumes.
      rows.forEach(function (row) {
        const addButton = row.querySelector('.pc-bundle-add');

        if (!addButton || addButton.disabled) {
          row.dataset.available = 'false';
          return;
        }

        row.dataset.available = 'true';

        const controls = document.createElement('div');
        controls.className = 'pc-bundle-quantity';
        controls.hidden = true;

        const minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'pc-bundle-minus';
        minus.textContent = '−';
        minus.setAttribute('aria-label', 'Remove one');

        const number = document.createElement('span');
        number.className = 'pc-bundle-number';
        number.textContent = '0';

        const plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'pc-bundle-plus';
        plus.textContent = '+';
        plus.setAttribute('aria-label', 'Add one more');

        controls.append(minus, number, plus);
        row.appendChild(controls);

        addButton.addEventListener('click', () => changeQuantity(row, 1));
        minus.addEventListener('click', () => changeQuantity(row, -1));
        plus.addEventListener('click', () => changeQuantity(row, 1));
      });

      // Update prices, progress, selections and buttons.
      function update() {
        const total = totalSelected();
        const remaining = limit - total;
        const normalPrice = limit * individualPrice;
        const saving = normalPrice - price;

        counter.textContent = total;
        limitDisplay.textContent = limit;
        priceDisplay.textContent = '£' + price.toFixed(2);
        compareDisplay.textContent = '£' + normalPrice.toFixed(2);
        savingDisplay.textContent = '£' + saving.toFixed(2);

        instruction.classList.toggle('is-complete', remaining === 0);

        if (remaining > 0) {
          instruction.textContent =
            'Choose ' + remaining + ' more ' +
            (remaining === 1 ? 'perfume' : 'perfumes') +
            ' to complete your bundle.';
        } else if (remaining === 0) {
          instruction.textContent = 'Your bundle is complete!';
        } else {
          const excess = Math.abs(remaining);

          instruction.textContent =
            'You have ' + excess + ' extra ' +
            (excess === 1 ? 'perfume' : 'perfumes') +
            '. Remove ' + excess +
            ' to continue with this bundle.';
        }

        // Selected-perfume summary
        summary.replaceChildren();

        if (total === 0) {
          const empty = document.createElement('p');
          empty.textContent = 'No perfumes selected yet.';
          summary.appendChild(empty);
        }

        selected.forEach(function (item, id) {
          const entry = document.createElement('div');
          entry.className = 'pc-selected-item';

          const name = document.createElement('span');
          name.textContent = item.quantity + ' × ' + item.title;

          const remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'pc-selected-remove';
          remove.textContent = 'Remove';

          remove.addEventListener('click', function () {
            selected.delete(id);
            update();
          });

          entry.append(name, remove);
          summary.appendChild(entry);
        });

        // Perfume-list controls
        rows.forEach(function (row) {
          if (row.dataset.available === 'false') return;

          const item = selected.get(row.dataset.variantId);
          const quantity = item ? item.quantity : 0;

          const add = row.querySelector('.pc-bundle-add');
          const controls = row.querySelector('.pc-bundle-quantity');
          const number = row.querySelector('.pc-bundle-number');
          const plus = row.querySelector('.pc-bundle-plus');

          add.hidden = quantity > 0;
          controls.hidden = quantity === 0;
          add.disabled = total >= limit;
          plus.disabled = total >= limit;
          number.textContent = quantity;
        });

        cartButton.disabled = total !== limit;

        if (total === limit) {
          cartButton.textContent = 'Add ' + limit + ' Perfumes to Cart';
        } else if (total > limit) {
          cartButton.textContent =
            'Remove ' + (total - limit) + ' perfumes';
        } else {
          cartButton.textContent =
            'Select ' + (limit - total) + ' more';
        }
      }

      // Switch bundle size while retaining selected perfumes.
      plans.forEach(function (plan) {
        plan.addEventListener('click', function () {
          limit = Number(plan.dataset.size);
          price = Number(plan.dataset.price);
          builder.dataset.bundleSize = String(limit);

          plans.forEach(function (other) {
            const active = other === plan;

            other.classList.toggle('is-selected', active);
            other.setAttribute('aria-pressed', String(active));
          });

          update();
        });
      });

      // Filter perfumes and prioritise exact reference matches.
      function filterPerfumes() {
        const query = search.value.trim().toLowerCase();

        if (!query) {
          rows.forEach(function (row) {
            row.hidden = false;
            list.appendChild(row);
          });

          list.scrollTop = 0;
          clearSearch.hidden = true;
          return;
        }

        const matching = rows.filter(function (row) {
          return (row.dataset.search || '').includes(query);
        });

        function priority(row) {
          const reference =
            (row.dataset.reference || '').toLowerCase();

          if (reference === query) return 0;
          if (reference.startsWith(query)) return 1;
          return 2;
        }

        matching.sort(function (a, b) {
          return priority(a) - priority(b);
        });

        rows.forEach(row => row.hidden = true);

        matching.forEach(function (row) {
          row.hidden = false;
          list.appendChild(row);
        });

        list.scrollTop = 0;
        clearSearch.hidden = false;
      }

      search.addEventListener('input', filterPerfumes);

      clearSearch.addEventListener('click', function () {
        search.value = '';
        filterPerfumes();
        search.focus();
      });

      // Add individual perfume variants to Shopify.
      // Functions Creator handles the one-time bundle merge.
      cartButton.addEventListener('click', async function () {
        if (totalSelected() !== limit) return;

        const items = Array.from(selected.entries()).map(
          function ([variantId, item]) {
            return {
              id: Number(variantId),
              quantity: item.quantity
            };
          }
        );

        cartButton.disabled = true;
        cartButton.textContent = 'Adding your bundle...';

        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ items: items })
          });

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add your bundle.'
            );
          }

          window.location.href = root + 'cart';
        } catch (error) {
          console.error('Dedicated bundle error:', error);

          alert(
            error.message ||
            'Something went wrong. Please try again.'
          );

          update();
        }
      });

      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseDedicatedBundles
    );
  } else {
    initialiseDedicatedBundles();
  }
})();